import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import React, { forwardRef, useMemo, Fragment } from 'react';
import 'prop-types';
import merge from 'deepmerge';
import ButtonBase from './ButtonBase.js';
import ButtonLoading from './ButtonLoading.js';
import useHover from '../../../utils/useHover.js';
import getPreferredValue from '../../../utils/getPreferredValue.js';
import btn from '../../../styles/btn.js';
import btnIcon from '../../../styles/btnIcon.js';
import btnLoading from '../../../styles/btnLoading.js';
import { margin1R } from '../../../styles/marginStatic/margin1R.js';
import { flexJustifyCenter } from '../../../styles/layout/flexJustifyCenter.js';
import { pad1Tb } from '../../../styles/padStatic/pad1Tb.js';
import { pad1 } from '../../../styles/padStatic/pad1.js';
import { jsx } from '@emotion/core';

const IconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    icon,
    children,
    loading,
    loadingStyle,
    size,
    allowOverflow,
    ...otherProps
  } = _ref;
  const [isHovering, hoverHandlerProps] = useHover(otherProps);
  const {
    disabled,
    theme
  } = otherProps;
  const {
    color
  } = useMemo(() => merge.all([btn.btn, theme['&:not(.btnContextual)'] ? theme['&:not(.btnContextual)'] : theme, disabled ? {
    ...(theme['&:disabled'] ? theme['&:disabled'] : btn.btn['&:disabled'])
  } : {}]), [theme, disabled]);
  const styleObject = useMemo(() => merge.all([size === 'sm' ? {
    ...btn.btnSm
  } : {}, btnIcon.btnIcon, allowOverflow ? btn.btnOverflow : {}, !children ? {
    ...btnIcon.btnIcon_btnSm_btnInline,
    ...flexJustifyCenter
  } : {}, loading ? btnLoading.btnLoading : {}, size !== 'sm' ? {
    maxHeight: '3.125rem',
    ...pad1Tb
  } : {}, size !== 'sm' && !children ? {
    ...pad1
  } : {}, theme]), [allowOverflow, size, loading, children, theme]);
  const iconToRender = /*#__PURE__*/React.cloneElement(icon, {
    filled: getPreferredValue(icon.props.filled, !disabled && isHovering),
    // eslint-disable-next-line unicorn/explicit-length-check -- false positive
    size: icon.props.size || size || 'md',
    theme: {
      ...(children ? margin1R : {}),
      fill: color,
      lineHeight: 0,
      ...icon.props.theme
    }
  });
  if (loading) {
    return jsx(ButtonLoading, _extends({
      size: size
    }, otherProps, hoverHandlerProps, {
      loadingStyle: loadingStyle,
      theme: styleObject,
      ref: ref
    }), iconToRender, children);
  }
  return jsx(ButtonBase, _extends({
    size: size
  }, otherProps, hoverHandlerProps, {
    theme: styleObject,
    ref: ref
  }), jsx(Fragment, {
    key: "icon"
  }, iconToRender), jsx(Fragment, {
    key: "children"
  }, children));
});
IconButton.displayName = 'IconButton';
IconButton.defaultProps = {
  children: null,
  allowOverflow: false
};
var IconButton$1 = IconButton;

export { IconButton$1 as default };
